import React, { useRef, useState, useContext } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

import Templete from "../../Templete/Templete";

import AuthService from "../../../../services/Admin/AuthService";
import BankMasterService from "../../../../services/Admin/BankMasterService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const AddBank = () => {
  const history = useHistory();

  const loadingCtx = useContext(LoadingContext);

  const [status, setStatus] = useState();

  const formRef = useRef();
  const bankNameRef = useRef();
  const accountNameRef = useRef();
  const accountNumberRef = useRef();
  const upiIDRef = useRef();
  const ifscCodeRef = useRef();
  const branchNameRef = useRef();

  const addBankHandler = async () => {
    const bankName = bankNameRef.current.value;
    const accountName = accountNameRef.current.value;
    const accountNumber = accountNumberRef.current.value;
    const upiID = upiIDRef.current.value;
    const ifscCode = ifscCodeRef.current.value;
    const branchName = branchNameRef.current.value;

    if (!bankName) {
      Swal.fire("Opps!", "Invalid Bank Name", "error");
      return;
    }

    if (!accountName) {
      Swal.fire("Opps!", "Invalid Account Name", "error");
      return;
    }

    if (!accountNumber) {
      Swal.fire("Opps!", "Invalid Account Number", "error");
      return;
    }

    if (!upiID) {
      Swal.fire("Opps!", "Invalid UPI ID", "error");
      return;
    }

    if (!branchName) {
      Swal.fire("Opps!", "Invalid Branch Name", "error");
      return;
    }

    if (!status) {
      Swal.fire("Opps!", "Invalid Status", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await BankMasterService.add(
        token,
        bankName,
        accountName,
        accountNumber,
        upiID,
        ifscCode,
        branchName,
        status
      );
      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        formRef.current.reset();
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Add Bank">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-default">
                  <div class="card-header">
                    <h3 class="card-title">Add Bank</h3>
                    <div class="card-tools">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm"
                        onClick={() => {
                          history.push("/admin/bank_list");
                        }}
                      >
                        Bank List
                      </button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <form ref={formRef} autoComplete="off">
                        <div class="card-body">
                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Bank Name
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Bank Name"
                                ref={bankNameRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Account Name
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Account Name"
                                ref={accountNameRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Account Number
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Account Number"
                                ref={accountNumberRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              UPI ID
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="UPI ID"
                                ref={upiIDRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              IFSC Code
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="IFSC Code"
                                ref={ifscCodeRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Branch Name
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Branch Name"
                                ref={branchNameRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Status
                            </label>
                            <div class="col-sm-10">
                              <select
                                name="title"
                                class="form-control"
                                onChange={(e) => {
                                  setStatus(e.target.value);
                                }}
                              >
                                <option value="">---Select Status---</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                          </div>

                          <div class="text-center">
                            <button
                              type="button"
                              class="btn btn-primary"
                              onClick={addBankHandler}
                            >
                              Submit
                            </button>
                            <button type="reset" class="btn btn-default ml-5">
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default AddBank;
